import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box, Flex } from '@adsk/alloy-react-box';
import { MenuItem } from '@adsk/alloy-react-menu';
import HighlightedItemText from './HighlightedItemText';
import { MFAIcon } from './MFAIcon';
import getAccountUrl from '../helpers/getAccountUrl';
import getAnchorRel from '../helpers/getAnchorRel';
import getAnchorTarget from '../helpers/getAnchorTarget';
import { accountShape } from '../helpers/propTypes';
const StyledImg = styled.img.withConfig({
  displayName: "ProjectListAccountItem__StyledImg",
  componentId: "sc-t2g6iy-0"
})(["width:48px;height:48px;border-radius:5px;margin-right:16px;"]);
const ProjectListAccountItem = _ref => {
  let {
    item: account,
    search,
    currentAccountId,
    currentProductId,
    onClose,
    onAccountClick,
    containerRef
  } = _ref;
  const url = getAccountUrl(account, currentProductId);
  const highlighted = currentAccountId === account.account_id;
  return /*#__PURE__*/React.createElement(MenuItem, {
    "data-testid": "ProjectPicker__Accounts-".concat(account.account_id),
    rel: getAnchorRel(url),
    highlighted: highlighted,
    showSelection: false,
    as: onAccountClick ? 'button' : 'a',
    href: url,
    target: getAnchorTarget(url),
    onClick: onAccountClick ? () => {
      onAccountClick(account, url);
      onClose === null || onClose === void 0 ? void 0 : onClose();
    } : onClose,
    style: {
      height: 'auto',
      padding: '8px 16px',
      textAlign: 'initial'
    }
  }, /*#__PURE__*/React.createElement(Flex, {
    flex: 1
  }, /*#__PURE__*/React.createElement(StyledImg, {
    src: account.image_url,
    "data-testid": "item-image"
  }), /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    flex: 1
  }, /*#__PURE__*/React.createElement(Box, {
    typography: "heading4",
    color: highlighted ? 'white' : 'charcoal900',
    ellipsis: "multi"
  }, /*#__PURE__*/React.createElement(HighlightedItemText, {
    text: account.account_display_name,
    search: search,
    highlighted: highlighted
  })), account.mfaBlocked && /*#__PURE__*/React.createElement(MFAIcon, {
    containerRef: containerRef
  }))));
};
ProjectListAccountItem.displayName = 'ProjectListAccountItem';
ProjectListAccountItem.propTypes = {
  /** The account item to show */
  item: accountShape,
  /** current selected account id */
  currentAccountId: PropTypes.string,
  /** current product ID, to check if project has entitlements for or not */
  currentProductId: PropTypes.string,
  /** menu close handler */
  onClose: PropTypes.func,
  /** account click handler */
  onAccountClick: PropTypes.func
};
export default ProjectListAccountItem;
//# sourceMappingURL=ProjectListAccountItem.js.map